// ----------      START   IMPORT  BLOCK        ----------
import React from 'react';
import type { MedicalSpecialty } from '../../../ConfigFiles/staticData/medicalSpecialties';
import type { MexicanState } from '../../../ConfigFiles/staticData/mexicanStates';
// ----------      END   IMPORT  BLOCK        ----------

type SearchResultItem = MedicalSpecialty | MexicanState;

interface SearchResultsListProps {
  items: SearchResultItem[];
  itemType: 'specialty' | 'state';
  langIdx: number;
  queryText: string;
  onSelect: (item: any) => void;
}

export const SearchResultsList: React.FC<SearchResultsListProps> = ({
  items,
  itemType,
  langIdx,
  queryText,
  onSelect,
}) => {
  if (items.length === 0) {
    return (
      <div className="search-dropdown search-scroll-handle animate-fade-in">
        <div className="dropdown-item-empty">
          {itemType === 'specialty' ? (
            <>Buscar <strong>"{queryText}"</strong></>
          ) : (
            'No se encontró el estado'
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="search-dropdown search-scroll-handle animate-fade-in">
      {items.map((item) => {
        const title =
          itemType === 'specialty'
            ? (item as MedicalSpecialty).specialist_name[langIdx]
            : (item as MexicanState).name;

        return (
          <div
            key={item.id}
            className="dropdown-item"
            onClick={() => onSelect(item)}
          >
            <span className="item-title">{title}</span>
          </div>
        );
      })}
    </div>
  );
};